import {Component, EventEmitter, Output} from '@angular/core';
import { IconComponent } from '../elements/icon/icon.component';
import { Icons } from '../../model/icon';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import { SectionService } from '../../services/section-service';
import {items} from '../../model/menu';

@Component({
  selector: 'app-header',
  imports: [
    IconComponent,
    NgForOf,
    NgClass,
    NgIf
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  constructor(public sectionService: SectionService) {}

  openWindow: boolean = false;

  file: string = 'app/assets/files/test.pdf';


  onSectionClick(sectionId: string) {
    if (this.openWindow) {
      this.openWindow = false;
    }
    this.sectionService.setActiveSection(sectionId);
    this.scrollToSection(sectionId);
  }

  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  protected readonly Icons = Icons;
  protected readonly items = items;
}
